/**
 * 公共router入口  避免 冲突 各自编写自己的模块
 * routerDefault 为默认路由
 * 编写自己的路由模块 然后导入  然后配置在routerConfig中 即可 ;
 */

import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

// import v3Router from "./module/version3Router"
import v3Router from './module/version3Router'
import v2Router from './module/version2Router'
import baseRouter from './module/silkRoadBaseRouter'
import pdRouter from '@/router/module/pdRouter'
import ybRouter from '@/router/module/ybRouter'

import ftaRouter from "@/router/module/ftaRouter";
// brpa 路由
import pbrRouter from './module/pbrRouter'

//brand二期路由
import brandRouter from './module/brandRouter'

Vue.use(Router)

// 路由合并配置
const routerConfig = {
    baseRouter,
    v3Router,
    v2Router,
    pdRouter,
    ftaRouter,
    pbrRouter,
    ybRouter,
    brandRouter
    // ...自定义路由 配置在这里
}

const routes = Object.values(routerConfig).reduce((pre, next) => [...pre, ...next], [])

const router = new Router({
    routes,
    linkActiveClass: 'column_active'
})

import VueGtm from 'vue-gtm'

Vue.use(VueGtm, {
    id: 'GTM-M4NVSC8', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router // Pass the router instance to automatically sync with router (optional)
})

router.afterEach((to, from, next) => {
    $('#bd-docs-nav').addClass('collapsed')
    $('#bd-docs-nav').attr('aria-expanded', false)
    $('#bd-docs-nav').removeClass('show')
    $('#bd-docs-nav').attr('aria-expanded', false)
    // 隐藏文章页面底部
    if ((to.path.indexOf('report') > 0 && to.path.indexOf('issue') > 0) || to.path.indexOf('article') > 0) {
        store.state.hasFooter = false
    } else {
        store.state.hasFooter = true
    }
    // window.scrollTo(0,0);
})
//解决ElementUI在导航栏中的vue-router在3.0版本重复点击出现报错的问题
// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => err)
// }
const KeepAliveRoute = []
routes.forEach((item) => {
  if (item.meta && item.meta.keepAlive) {
    KeepAliveRoute.push(item.name)
  }
})
//三期项目权限
router.beforeEach((to, from, next) => {

  const routeSearchName = ['searchDetail', 'SearchType']
  const routeTopName = ['fullTopics']
  // debugger
  if (KeepAliveRoute.indexOf(to.name) !== -1) {
    if (to.name === from.name) {
      from.meta.keepAlive = false
      to.meta.keepAlive = true
    } else if (routeTopName.indexOf(to.name) !== -1) {
      // 全屏特殊逻辑
      to.meta.keepAlive = routeSearchName.indexOf(from.name) !== -1
      from.meta.keepAlive = routeSearchName.indexOf(from.name) === -1
    } else if (routeSearchName.indexOf(to.name) !== -1) {
      // 跳转搜索 逻辑
      from.meta.keepAlive = from.name !== 'searchDetail'
      to.meta.keepAlive = false
    } else {
      from.meta.keepAlive = false
    }
  } else if (KeepAliveRoute.indexOf(from.name) !== -1) {
    from.meta.keepAlive = false
  }

  if (KeepAliveRoute.indexOf(to.name) !== -1) {
    to.meta.keepAlive = true
  }

  const power = localStorage.getItem('list') || []
  if (power !== null && power.length > 0) {
    const menu = JSON.parse(power)
    if (to.meta.per) {
      if (menu !== null && menu.length > 0) {
        const newMenu = menu.filter(item => item === to.meta.per)
        if (!newMenu.length) {
          Message.error('Sorry, insufficient permissions!')
          next('/brand/BigFrame/Home')

                } else {
                    next()
                }
            }
        }
    }
    next()
    // TODO 以下来自censLi分支的逻辑可能根据登录流程做修改
})

export default router
